import { first } from 'lodash';
import placeholder_url from '../../../../placeholder';
import pathToContent from './helpers/path_to_content';
import ArticleItemList from './helpers/ArticleItemList';
import { makeT } from "../../../location/locales";

const textFromCategory = (category, t) => {
  switch (category) {
    case 'Blog': return t('builder.data.read_more');
    case 'Case Study': return t('builder.data.read_more');
    case 'Document': return t('builder.data.read_more');
    case 'Video': return 'Watch Now';
    case 'Podcast': return 'Listen Now';
    case 'Learning Center': return 'Learn More';
    default: return t('builder.data.read_more');
  }
}

const iconFromCategory = (category) => {
  switch (category) {
    case 'Blog': return 'newspaper-o';
    case 'Case Study': return 'briefcase';
    case 'Document': return 'file';
    case 'Video': return 'video-camera';
    case 'Podcast': return 'podcast';
    case 'Learning Center': return 'lightbulb-o';
    default: return 'newspaper-o';
  }
}

const mapItemFromData = (content) => {
  if (!content) {
    return null;
  }
  const { metadata } = content || {}
  const { settings: { details = {} } = {} } = metadata || {};
  const t = makeT(Board.build.language);
  return (
    {
      metadata,
      image: details?.image?.file ? details.image : { file: placeholder_url(370,185) },
      img: details?.image?.file || placeholder_url(370,185),
      alt: details?.image?.alt,
      prehead: [
        details?.taxonomies?.primary_category || first(details?.taxonomies?.categories)
      ].filter(x => x).join(' • '),
      heading: details?.information?.title,
      text: details?.information?.description,
      linkText: textFromCategory(details?.taxonomies?.article_type, t),
      url: pathToContent(content),
      icon: iconFromCategory(details?.taxonomies?.article_type)
    }
  );
};

export default
  ArticleItemList({
    search: {
      name: 'Roofing Blog Articles',
      type: 'Article::Roofing',
      preview: result => ({
        preheading: result.category,
        heading: result.proper_name
      })
    },
    list: {
      availableIn: ['www.owenscorning.com'],
      name: 'Blog - Roofing',
      attributeSet: {
        name: 'Roofing Article Attributes',
        path: 'roofing/blog'
      },
      dataset: 'roofing_blog',
      itemListMap: mapItemFromData,
      cardSetMap: mapItemFromData,
      categoryFeaturesMap: mapItemFromData,
      enableSearch: true,
    }
  })
